import styles from "./headerTitle.module.scss";

interface IHeaderTitle {
  children: string | React.ReactNode;
}

const HeaderTitle = ({ children }: IHeaderTitle) => {
  return <h2 className={styles.HeaderTitle}>{children}</h2>;
};

export default HeaderTitle;
